// extracted by mini-css-extract-plugin
export var productImage = "_r9-1";
export var viewLink = "_r9-2";
export var wishlistItem = "_r9-0";